(function () {
  'use strict';

  var LS_KEY = 'rad-animations-paused';
  var HTML_CLASS = 'animations-paused';

  // ─── State helpers ────────────────────────────────────────────────────────

  function readInitialPaused() {
    try {
      var stored = localStorage.getItem(LS_KEY);
      if (stored !== null) return stored === 'true';
    } catch (e) {}
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function savePaused(paused) {
    try {
      localStorage.setItem(LS_KEY, String(paused));
    } catch (e) {}
  }

  // ─── DOM state ────────────────────────────────────────────────────────────

  function setHtmlClass(paused) {
    document.documentElement.classList.toggle(HTML_CLASS, paused);
  }

  function updateButton(paused) {
    var btn = document.getElementById('animation-toggle-btn');
    if (!btn) return;
    btn.setAttribute('aria-label', paused ? 'Play animations' : 'Pause animations');
    btn.setAttribute('aria-pressed', String(paused));
  }

  // ─── GIF pausing ──────────────────────────────────────────────────────────

  function gifImages() {
    return Array.prototype.slice.call(
      document.querySelectorAll('img.additional-media, img.additional-media--image-tag, .section-brand-statement img, .collapsible-content__media img, .video-section__poster img, .icon-with-text img, .product-feature img')
    ).filter(function (img) {
      var url = (img.currentSrc || img.src || '').toLowerCase();
      return url.indexOf('.gif') !== -1;
    });
  }

  /** Returns a static (first-frame) version of a Shopify CDN GIF URL. */
  function staticSrc(src) {
    var sep = src.indexOf('?') !== -1 ? '&' : '?';
    return src + sep + 'format=jpg';
  }

  function freezeGif(img) {
    if (img.dataset.gifSrc) return;
    // currentSrc reflects the srcset-chosen URL; use it as the static base
    var original = img.currentSrc || img.src;
    img.dataset.gifSrc = img.src;
    if (img.srcset) {
      img.dataset.gifSrcset = img.srcset;
      img.removeAttribute('srcset');
    }
    img.src = staticSrc(original);
  }

  function unfreezeGif(img) {
    if (!img.dataset.gifSrc) return;
    img.src = img.dataset.gifSrc;
    delete img.dataset.gifSrc;
    if (img.dataset.gifSrcset) {
      img.srcset = img.dataset.gifSrcset;
      delete img.dataset.gifSrcset;
    }
  }

  function freezeAllGifs() {
    gifImages().forEach(freezeGif);
  }

  function unfreezeAllGifs() {
    document.querySelectorAll('img[data-gif-src]').forEach(unfreezeGif);
  }

  // ─── Video pausing ────────────────────────────────────────────────────────

  function bannerVideos() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.section-image-banner video, .video-component video, .product-feature video')
    );
  }

  function pauseAllBannerVideos() {
    bannerVideos().forEach(function (video) {
      if (video.hasAttribute('autoplay')) {
        video.dataset.hadAutoplay = 'true';
        video.removeAttribute('autoplay');
      }
      if (!video.paused) {
        video.pause();
        video.dataset.pausedByToggle = 'true';
      }
    });
  }

  function playAllBannerVideos() {
    bannerVideos().forEach(function (video) {
      var shouldPlay = video.dataset.pausedByToggle === 'true' || video.dataset.hadAutoplay === 'true';
      if (video.dataset.hadAutoplay === 'true') {
        video.setAttribute('autoplay', 'autoplay');
        delete video.dataset.hadAutoplay;
      }
      if (video.dataset.pausedByToggle === 'true') {
        delete video.dataset.pausedByToggle;
      }
      if (shouldPlay) {
        video.play();
      }
    });
  }

  // ─── Full state application ───────────────────────────────────────────────

  function applyState(paused) {
    setHtmlClass(paused);
    updateButton(paused);
    if (paused) {
      freezeAllGifs();
      pauseAllBannerVideos();
    } else {
      unfreezeAllGifs();
      playAllBannerVideos();
    }
  }

  // ─── Bootstrap ───────────────────────────────────────────────────────────

  setHtmlClass(readInitialPaused());

  document.addEventListener('DOMContentLoaded', function () {
    var paused = readInitialPaused();

    applyState(paused);

    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () {
        if (document.documentElement.classList.contains(HTML_CLASS)) {
          freezeAllGifs();
          pauseAllBannerVideos();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    var btn = document.getElementById('animation-toggle-btn');
    if (btn) {
      btn.addEventListener('click', function () {
        var nowPaused = !document.documentElement.classList.contains(HTML_CLASS);
        savePaused(nowPaused);
        applyState(nowPaused);
      });
    }
  });
})();
